import { Card, Icon, Overlay } from '@/components/atoms';
import { cva, VariantProps } from 'class-variance-authority';
import { AnimatePresence, motion } from 'framer-motion';
import { FC, PropsWithChildren, ReactNode, useEffect, useState } from 'react';

const popupStyles = cva('', {
  variants: {
    size: {
      small: ['w-[518px]', 'h-[348px]'],
      default: ['w-[518px]', 'h-[697px]'],
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

interface Props extends PropsWithChildren, VariantProps<typeof popupStyles> {
  open?: boolean;
  onClose?: () => void;
}

const Popup: FC<Props> = ({ children, onClose, size, open = false }) => {
  const [isOpen, setIsOpen] = useState(open);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const handleOnClose = () => {
    setIsOpen(false);
    onClose && onClose();
  };

  return (
    <AnimatePresence mode="wait">
      {isOpen && (
        <div className="fixed flex justify-center items-center w-full h-full top-0 bottom-0 left-0 right-0">
          <Overlay />
          <Card className={popupStyles({ size, className: 'z-40 fixed' })}>
            <Card.Header
              right={
                <div onClick={handleOnClose}>
                  <Icon name="close" />
                </div>
              }
            />
            {children}
          </Card>
        </div>
      )}
    </AnimatePresence>
  );
};

export default Popup;
